//import Glide from '../../vendors/@glidejs/glide/dist/glide.esm.js';
import Glide from '@glidejs/glide';

class GlideSlideshow {
  constructor(el, options) {
    this.el = el;
    this.options = options;

    this.glideArrowsEl = this.el.querySelector('.glide__arrows');

    this.id = this.el.getAttribute('id');

    this.glide = undefined;

    this.countSlides = this.el.querySelectorAll('.glide__slide').length;

    this._init();
  }


  /*
   * INIT
   */
  _init() {
    this.glide = new Glide(this.el, {
      type: 'carousel',
      autoplay: this.options?.autoplay ? 8000 : false,
      animationDuration: 800,
      keyboard: true,
      hoverpause: false,
      gap: 0,
      swipeThreshold: 30
    });

    //update active caption
    if(this.el.querySelectorAll('[data-glide-caption]').length > 0)
      this.el.querySelectorAll('[data-glide-caption]')[0].classList.add('active');

    this.glide.on('run', move => {
      //update active caption
      if(this.el.querySelectorAll('[data-glide-caption]').length > 0) {
        this.el.querySelectorAll('[data-glide-caption]').forEach(el => {
          el.classList.remove('active');
        });
        this.el.querySelectorAll('[data-glide-caption]')[this.glide.index].classList.add('active');
      }

      //update counter
      if(this.el.parentElement.querySelector('[data-glide-counter]'))
        this.el.parentElement.querySelector('[data-glide-counter] [data-glide-current]').innerHTML = (this.glide.index +1);
    });

    //click to go to next slide
    // this.el.querySelector('.glide__track').addEventListener('click', () => this.glide.go('>'));

    //update counter
    if(this.el.parentElement.querySelector('[data-glide-counter]')) {
      this.el.parentElement.querySelector('[data-glide-counter] [data-glide-current]').innerHTML = 1;
      this.el.parentElement.querySelector('[data-glide-counter] [data-glide-total]').innerHTML = this.countSlides;
    }

    this.el.querySelectorAll('.glide__arrow').forEach(el => {
      const labelEl = el.querySelector('[data-follow-cursor]');
      el.addEventListener('mouseenter', e => el.classList.add('glide__arrow--show-label'));
      el.addEventListener('mouseleave', e => el.classList.remove('glide__arrow--show-label'));

      el.addEventListener('mousemove', e => {
        labelEl.style.left = (e.clientX - el.getBoundingClientRect().left - labelEl.getBoundingClientRect().width/2) +'px';
        labelEl.style.top = (e.clientY - el.getBoundingClientRect().top - labelEl.getBoundingClientRect().height/2) +'px';
      });
    });

    if(this.countSlides > 1) {
      //init/mount slide
      this.glide.mount();

      if(this.glideArrowsEl)
        this.glideArrowsEl.classList.remove('base-hero__slideshow-arrows--hide');
    }
  }

  /*
   * Destroy
   */
  destroy() {
    this.glide.destroy();
  }
};
export default GlideSlideshow;
